import { IPublicClientApplication } from "@azure/msal-browser";
import { apiLoginRequest } from "../Config";
import { AppStatusModel } from "../Models/AppStatusModel";

export default class StatusesService {

    msalInstance: IPublicClientApplication;

    constructor(msalInstance: IPublicClientApplication) {
        this.msalInstance = msalInstance;
    }

    public async getAppStatuses(): Promise<AppStatusModel[]> {
        const baseUrl = process.env.REACT_APP_API_URL;
        const accessToken = await this.acquireAccessToken();

        const statuses = await fetch(baseUrl + '/api/Status', {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
            })
        }).then(function (response) {
            return response.json();
        });

        return statuses;
    }

    private async acquireAccessToken() {
        const account = this.msalInstance.getActiveAccount();
        if (!account) {
            throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
        }

        const authResult = await this.msalInstance.acquireTokenSilent({
            ...apiLoginRequest,
            account: account
        });

        return authResult.accessToken;
    };
}